import React from "react";
import { Resources } from "../../../constants/constants";
import Helpers from "../../../constants/helpers";

export const TermsAndConditions = ({
    appendDepositMessage = false,
    useISlashWe = false,
    useHyperLinkStyle = true,
    hyperLinkColor = null,
}) => {
    const defaultLinkColor = "text-color-gray-16";
    const linkColor = hyperLinkColor || defaultLinkColor;
    const hyperLinkCss = useHyperLinkStyle
        ? "text-color-gray-16 text-underline"
        : `${linkColor} text-underline`;

    const fsgLink = Helpers.getBlobFileUrl(Resources.Common.PDF_FSG);
    const depositMsg = "and you authorise InvestSMART Financial Services Pty Ltd to deposit payments into the nominated account.";

    return <span className="font-16 text-blue blue-links-container">
        {useISlashWe ? 'I/We' : 'I'} agree to the <a className={hyperLinkCss} href={fsgLink} target="_blank" rel="noreferrer" title="Financial Services Guide">FSG</a>, <a className={hyperLinkCss} href="/privacy-policy" target="_blank" rel="noreferrer" title="Privacy Policy">Privacy Policy</a> & <a className={hyperLinkCss} href="/terms-and-conditions" target="_blank" rel="noreferrer" title="Terms of Use">Terms</a>{appendDepositMessage ? ` ${depositMsg}` : '.'}
    </span>
}


